import { Component, } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Http, Headers } from '@angular/http';
import { NavModalComponent } from '../core/component/NavModal.Component';
import { AdmissionFormService } from './admisformservice';
import { UserService } from '../core/service/user.service';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { PatternConstants } from '../shell/shared/pattern.constants';


@Component({
  selector: 'admisform',
  templateUrl: './admisform.component.html',
  styleUrls: ['./admisform.component.css']
})
export class AdmisformComponent extends NavModalComponent<any> {

  step: any = 1;
  myForm: FormGroup;
  studentForm: FormGroup;
  data: any = {};
  campuslist = [];
  clientid: number = 141 ;
  rows = [];
  country: any;
  fathername: any;
  state: any;
  city: any;
  Address: any;
  childName: any;
  entity: any;
  phoneNo: any;
  Cellno: any;
  Email: any;
  Class: any;
  DateOfbirth: any;
  gender: any;
  relation: any;
  lbladdress: any;
  lblcontactno: any;
  lblcountry: any;
  course: any;
  RealtionTypes = [];
  contryid: number;
  loginToken: any;
  public mobilem = PatternConstants.pattern.mobile;
  public phonem = PatternConstants.pattern.mobile;
  userName: string ;
  passWord: string ;
  private countryurl = 'https://sm.edu-man.com/sm/api/Country/V2/ClientCountry/'
  private stateurl  = 'https://sm.edu-man.com/sm/api/State/V2/ClientState/'
  private cityurl  = 'https://sm.edu-man.com/sm/api/City/V2/ClientCity/'
  private entityurl  = 'https://sm.edu-man.com/sm/api/Legalentity/V2/CampusList/'
  private relationurl = 'https://sm.edu-man.com/sm/api/Relationtype/v2/'
  private courseurl = 'https://sm.edu-man.com/sm/api/SMCourse/v2/ClientCourse/'
  private genderUrl = 'https://sm.edu-man.com/sm/api/lov/v2/List/GTYPE'
  private admappurl = 'https://sm.edu-man.com/sm/api/FOAdmEnquiry/v2'

  // private countryurl = 'http://192.168.1.117:4324/sm/api/Country/V2/ClientCountry/';
  // private stateurl = 'http://192.168.1.117:4324/sm/api/State/V2/ClientState/'
  // private cityurl = 'http://192.168.1.117:4324/sm/api/City/V2/ClientCity/';
  // private entityurl = 'http://192.168.1.117:4324/sm/api/Legalentity/V2/CampusList/';
  // private relationurl ='http://192.168.1.117:4324/sm/api/Relationtype/v2/';
  // private courseurl = 'http://192.168.1.117:4324/sm/api/SMCourse/v2/ClientCourse/';
  // private genderUrl = 'http://192.168.1.117:4324/sm/api/lov/v2/List/GTYPE'
  // private admappurl = 'http://192.168.1.117:4324/sm/api/FOAdmEnquiry/v2/';



  constructor(
    private admissionFormService: AdmissionFormService,
    private _httpClient: Http,
    private userService: UserService,
  ) {
    super(admissionFormService);
    // this.getData().subscribe((i: ConstantClass) => {
    //   
    //   if (
    //     i.Clients.length > 0 &&
    //     i.Clients.filter((o) => o.hostname === window.location.hostname)[0]
    //   ) {
    //     let obj = i.Clients.filter(
    //       (o) => o.hostname === window.location.hostname
    //     )[0];
        
    //     
    //     if (obj && Number(obj.Id) > 0) {
    //       this.clientid = Number(obj.Id);
    //     }
    //     this.localStorage.set("clientid", obj.Id)
         
    //     if(obj != null) {
    //       this.userName = obj.username,
    //       this.passWord = obj.password
    //     }
    //     
     

    //   }

    // });

  }

  async ngOnInit() {
    this.initializeForm();
    // if(this.userName != null && this.passWord !=null && this.clientid != null){
    //   
    //   let username = this.userName;
    //   let password = this.passWord;
    //   let clientid = this.clientid;
    //   await  this.login(username , password , clientid);
    //   
    // }
    await this.login("cshaffan" , "csh@@!!edu" ,141 )
    
  }

  initializeForm() {

    this.myForm = this.fb.group({

      countryid: ['', [Validators.required]],
      stateid: ['', [Validators.required]],
      cityid: ['', [Validators.required]],
      entityid: ['', [Validators.required]],
      relationtypeid: ['', [Validators.required]],
      name: ['', [Validators.required]],
      cellno: ['', [Validators.required]],
      phoneno: ['',],
      address: ['', [Validators.required]],
      email: ['',],
      noofchild: ['', [Validators.required]],
      sourcetypeid: 901,
      resptypeid: 162,
      followupdate: new Date(),
      nextfollowup: new Date(),
    })
    this.studentForm = this.fb.group({
      courseid: ['', [Validators.required]],
      genderid: ['', [Validators.required]],
      childname: ['', [Validators.required]],
      dob: ['',],
    });
  }

  public getData(): Observable<any> {
    
    const a = this._httpClient
      .get("../../assets/IXS/resultJSON.json")
      .map((res: any) => {
        return res.json();
      });
    return a;
  }


  getInfo() {

    if (this.data) {

        this.fathername = this.data.name,
        this.Cellno = this.data.cellno,
        this.phoneNo = this.data.phoneno,
        this.Email = this.data.email,
        this.Address = this.data.address

    }

  }


  // async login( username, password){
  //   
  //   var obj = {
  //     data: {
  //         user: {
  //             "Username": username,
  //             "Password": password
  //         }
  //     }
  //  }

  //  var baseurl = "http://ut.edu-man.com:4323/ut/api/utuser/v2/loginV3";

  //  const headers = new Headers({
  //    'content-type': 'application/json',
  //    'content-lenght':'<calculated when request is sent>',
  //    data: JSON.stringify(obj)
  //  });
  //  
  //  this._httpClient.put(baseurl , obj ,{headers : headers}).subscribe((res) =>{

  //   if(res == null){
  //       console.log("wrong username and password")
  //   }

  //   else{
  //     this.loginToken = res.z;
  //   }
  //   

  //  },err =>{
  //       console.log("Erro with api")
  //  })
  //  
  // }


  async login(username: string , password : string , clientid:any) {

    
    var dto = await this.userService.login(
      username,
      password,
      clientid,
   
      );
      
    
    if (dto && dto.Data && dto.Data.Session) {
      this.localStorage.set("token", "bearer ".concat(dto.Data.Session.token));

      this.loginToken = dto.Data.Session.token;
      localStorage.setItem("token", `${this.loginToken}`);
    }
    if (dto && dto.IsSuccess) {
      await this.getCountryClient(this.clientid);
      await this.getrelation();
      await this.getgenders();
    }
  }

  addItem() {

    let Courseid = this.studentForm.controls['courseid'].value
    let Dob = this.studentForm.controls['dob'].value
    let Genderid = this.studentForm.controls['genderid'].value;
    let Childname = this.studentForm.controls['childname'].value;

    if (!Courseid || !Dob || !Childname || !Genderid) {

      Swal.fire({

        title: 'Error!',
        text: 'Please provide proper info of student!',
        icon: 'error',
        confirmButtonText: 'Ok'

      });
    }

    else if (Dob) {
      var dateString = this.studentForm.controls['dob'].value;
      var myDate = new Date(dateString).toDateString();
      var today = new Date().toDateString();
      if (new Date(myDate) >= new Date(today)) {

        Swal.fire({
          title: 'Error!',
          text: 'Date of birth cannot be Equal to the current date!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })
        return false;

      } else {
        let record = {

          Courseid: Courseid != undefined ? Courseid : '',
          Dob: Dob != undefined ? Dob : '',
          Genderid: Genderid != undefined ? Genderid : '',
          Childname: Childname != undefined ? Childname : '',
        };
        this.rows.push(record);
        this.studentForm.reset();
      }
    }

  }

  removeItem(element) {

    this.rows.forEach((value, index) => {
      if (value == element)
        this.rows.splice(index, 1);
    });
  }



  nextButton() {

    if (this.step == 1) {
      if (!this.myForm.controls['countryid'].value || !this.myForm.controls['stateid'].value || !this.myForm.controls['cityid'].value || !this.myForm.controls['entityid'].value) {
        Swal.fire({
          title: 'Error',
          text: 'Please provide campus info for futher process!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
      else {
        this.step++;
      }
    }

    else if (this.step == 2) {
      if (!this.myForm.controls['relationtypeid'].value || !this.myForm.controls['name'].value || !this.myForm.controls['cellno'].value || !this.myForm.controls['address'].value || !this.myForm.controls['noofchild'].value) {
        Swal.fire({
          title: 'Error',
          text: 'Please provide guardian info for futher process!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
      else {
        this.step++;
      }

      this.setValues();
    }

    else if (this.step == 3) {
      if (this.rows && this.rows.length == 0) {
        Swal.fire({
          title: 'Error',
          text: 'Please provide student info for futher process!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
      else {
        this.data = this.myForm.value;
        this.getInfo();
        this.step++;
      }
    }
  }
  prevButton() {
    this.step--;
  }

async  onSubmit() {
  
    if (this.rows && this.rows.length && this.rows.length > 0) {
      this.data.FOAdmEnquirydtls = this.rows;
    }
   await this.postAdmissionForm();
  
  }


  async getCountryClient(clientid) {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + this.loginToken);

    var requestOptions = {
     method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
    };
    var url = this.countryurl + this.clientid
    this._httpClient.get(url, requestOptions).subscribe((res) => {

      const dto = res.json();
      this.LookupData.country = dto.Data;

    }, err => {
      console.log("something went wrong with service" + err)
    });

  }

  async getState(countryid, clientid) {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + this.loginToken);

    var requestOptions = {
     method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
    };


    this.contryid = this.myForm.controls['countryid'].value;
    var url = this.stateurl + this.contryid + '/' + this.clientid;
    this._httpClient.get(url, requestOptions).subscribe((res) => {

      const dto = res.json();
      this.LookupData.state = dto.Data;

    }, err => {
      console.log("Something went wrong with service")
    })




  }

  async getCity(countryid, stateid, clientid) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + this.loginToken);

    var requestOptions = {
     method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
    };

    this.contryid = this.myForm.controls['countryid'].value;
    var stateid = this.myForm.controls['stateid'].value;
    var url = this.cityurl + this.contryid + '/' + stateid + '/' + this.clientid;
    this._httpClient.get(url, requestOptions).subscribe((res) => {

      const dto = res.json();
      this.LookupData.city = dto.Data;

    }, err => {
      console.log("Something went wrong with service")
    })
  }
  async getEntities(countryid, stateid, cityid, clientid) {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + this.loginToken);

    var requestOptions = {
     method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
    };
    this.contryid = this.myForm.controls['countryid'].value;
    var stateid = this.myForm.controls['stateid'].value;
    var cityid = this.myForm.controls['cityid'].value;
    var url = this.entityurl + this.contryid + '/' + stateid + '/' + cityid + '/' + this.clientid;
    this._httpClient.get(url, requestOptions).subscribe((res) => {

      const dto = res.json();
      this.LookupData.entities = dto.Data;

    }, err => {
      console.log("Something went wrong with service")
    })

  }

  async getrelation() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + this.loginToken);

    var requestOptions = {
     method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
    };

    this._httpClient.get(this.relationurl, requestOptions).subscribe((res) => {
      const dto = res.json();
      this.LookupData.relations = dto.Data;
    })

  }

  async getCourse(entityid) {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + this.loginToken);

    var requestOptions = {
     method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
    };

    var entityid = this.myForm.controls['entityid'].value
    var url = this.courseurl + entityid
    this._httpClient.get(url, requestOptions).subscribe((res) => {
      const dto = res.json();
      this.LookupData.courses = dto.Data;
    }, err => {
      console.log("something went wrong with service")
    });

  }

  async getgenders() {
    
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "bearer " + this.loginToken);

    var requestOptions = {
     method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
    };
    

    this._httpClient.get(this.genderUrl, requestOptions).subscribe(res=>{
    const dto = res.json();
    this.LookupData.Genders = dto.Data;
    });
    

}

  setValues() {

    if (this.LookupData.entities && this.LookupData.entities.length > 0) {
      var ab = this.LookupData.entities.filter(w => w.entityid === this.myForm.controls['entityid'].value)[0];
      if (ab) {
        this.lbladdress = ab.address;
        this.lblcontactno = ab.contactno;
        this.entity = ab.stxt
      }


      if (this.LookupData.country && this.LookupData.country.length > 0)
        var ab = this.LookupData.country.filter(w => w.Id === this.myForm.controls['countryid'].value)[0];
      if (ab) {
        this.country = ab.countryname;

      }

      if (this.LookupData.state && this.LookupData.state.length > 0)
        var ab = this.LookupData.state.filter(w => w.Id === this.myForm.controls['stateid'].value)[0];
      if (ab) {
        this.state = ab.stxt;
      }

      if (this.LookupData.city && this.LookupData.city.length > 0)
        var ab = this.LookupData.city.filter(w => w.Id === this.myForm.controls['cityid'].value)[0];
      if (ab) {
        this.city = ab.citystxt;
      }

      if (this.LookupData.relations && this.LookupData.relations.length > 0)

        var ab = this.LookupData.relations.filter(w => w.Id === this.myForm.controls['relationtypeid'].value)[0];
      if (ab) {
        this.relation = ab.stxt;
      }



      // if (this.LookupData.course && this.LookupData.course.length > 0)
      //   var ab = this.LookupData.course.filter(w => w.Id === this.myForm.controls['courseid'].value)[0];
      // if (ab) {
      //   this.course = ab.stxt;

      // }

      // if (this.LookupData.Genders && this.LookupData.Genders.length > 0)
      //   var ab = this.LookupData.Genders.filter(w => w.Id === this.myForm.controls['genderid'].value)[0];
      // if (ab) {
      //   this.gender = ab.stxt;

      // }

    }

  }

  async postAdmissionForm() {
    var dto = {
      Data: {
        relationtypeid: this.myForm.controls['relationtypeid'].value,
        name: this.myForm.controls['name'].value,
        address: this.myForm.controls['address'].value,
        phoneno: this.myForm.controls['phoneno'].value,
        cellno: this.myForm.controls['cellno'].value,
        entityid: this.myForm.controls['entityid'].value,
        resptypeid: this.myForm.controls['resptypeid'].value,
        sourcetypeid: this.myForm.controls['sourcetypeid'].value,
        followupdate: this.myForm.controls['followupdate'].value,
        nextfollowup: this.myForm.controls['nextfollowup'].value,
        noofchild: this.myForm.controls['noofchild'].value,
        FOAdmEnquirydtls: this.rows
      }
    }

    
    const headers = new Headers({
      'content-type': 'application/json',
      'content-lenght': '<calculated when request is sent>',
      'authorization': "bearer " + this.loginToken
    });
    var url = this.admappurl;
    this._httpClient.post(url, dto, { headers: headers })
      .subscribe(res => {

        Swal.fire(
          'Good job!',
          'Admission registration successful!',
          'success'
        )
        this.myForm.reset();
        this.step = 1;

        this.fathername = undefined;
        this.country = undefined;
        this.entity = undefined;
        this.city = undefined;
        this.state = undefined;
        this.relation = undefined;
        this.lbladdress = undefined;
        this.lblcontactno = undefined;
        this.Cellno = undefined;
        this.phoneNo = undefined;
        this.Email = undefined;
        this.Address = undefined;
        this.rows = [];

      }, err => {

        Swal.fire({
          title: 'Error!',
          text: 'Admission registration unsuccessful!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })


      });
  }

}
export class ConstantClass {
  Clients: Clients[];
}

interface Clients {
  Id: Number;
  code: string;
  name: string;
  description: string;
  hostname: string;
  filename: string;
  height: any;
  width: any;
  username: string;
  password: string;
}















// WEBPACK FOOTER //
// ./src/app/admisform/admisform.component.ts